import { render, staticRenderFns } from "./EducationalItemsTable.vue?vue&type=template&id=6de32bf8&scoped=true&"
import script from "./EducationalItemsTable.vue?vue&type=script&lang=js&"
export * from "./EducationalItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./EducationalItemsTable.vue?vue&type=style&index=0&id=6de32bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de32bf8",
  null
  
)

export default component.exports